import { SocketEvent } from '@/services/ws/core/event'

class UpdateBalanceEvent extends SocketEvent {
  async handle(data, { store }) {
    const balance = data?.balance
    balance && store.dispatch('user/act_userBalance', balance)
  }
}

export const updateBalanceEvent = new UpdateBalanceEvent()
